/**
 *
 * @param {string} hash1 The hash to compare against
 * @param {string} hash2 The string to compare to the hash.
 * @returns {Promise<boolean>}
 */
export function compareHash(hash1, hash2) {
  const promises = Promise.all([
    Promise.resolve(hash1),
    createHash(hash2),
  ])

  return promises.then(values => {
    return values[0] === values[1];
  })
}

export function createHash(val) {
  return crypto.subtle
    .digest('SHA-256', new TextEncoder('utf-8').encode(val))
    .then(h => {
      let hexes = [],
        view = new DataView(h);
      for (let i = 0; i < view.byteLength; i += 4)
        hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
      return hexes.join('');
    });
}



// WEBPACK FOOTER //
// ./scripts/util/asyncHash.js